<template>
  <!-- 添加或修改设备调换记录对话框 -->
  <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body>
    <div class="details_top">
<el-checkbox :indeterminate="isIndeterminate"  v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      <el-button type="primary" @click="handleDelete(2)">批量删除</el-button>
    </div>
     
          <div class="faceDatabase">   
      <!-- <div
        class="faceDatabase_box"
        v-for="(item, index) in detailsForm"
        :key="index"
      > -->
        <el-checkbox-group v-model="checkedIds" @change="handleCheckedItemsChange">
    <el-checkbox   v-for="(item) in detailsForm"
        :key="item.faceToken" :label="item.faceToken">
       <div  class="faceDatabase_box">
         <div class="faceDatabase_box_imgBox">
          <image-preview :src="item.url" :width="100" :height="100" />
          <!-- <img :src="item.url" class="faceDatabase_box_img" alt="" /> -->
        </div>
        <span class="faceDatabase_box_name">{{ item.createUser }}</span>
        <span class="faceDatabase_box_time">{{ item.createTime }}</span>
        <div class="faceDatabase_box_btnBox">
          <el-button
            size="mini"
            type="danger"
            round
            plain
            @click.stop="handleDelete(1,item)"
            >删除</el-button
          >
        </div>
       </div>
    </el-checkbox>
  </el-checkbox-group>
      </div>
      <div class="faceDatabase_empty">
        <el-empty description="暂无内容" v-if="detailsForm.length == 0"></el-empty>
      </div>
    <!-- </div> -->
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="cancel">确 定</el-button>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { faceLibraryImg, faceLibrarydelFace } from "@/api/faceDatabase";
import "@/assets/imgList.css";
export default {
  components: {},
  data() {
    return {
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      btnShow: false,
      detailsNum: 3,
      detailsForm: [],
      id: null,
      // 存储被选中项的 id
      checkedIds: [],
      // 控制全选框是否为全选状态
      checkAll: false,
      // 控制全选框的“半选”状态（当不是全选也不是全不选时）
      isIndeterminate: false
    }
  },
  methods: {
    addCreateForm(record) {
      this.open = true
      this.title = '详情'
     this.id = record.id
     this.getImgFun()
    },   
    getImgFun(){
 faceLibraryImg({libraryId:this.id}).then(response => {
          this.detailsForm = response.data.data
      })
    },
      handleDelete(type,row) {
        const id = this.id
      let faceTokenList = []
      if(type == 1){
      faceTokenList.push(row.faceToken)
      }else if(type == 2){
        faceTokenList = this.checkedIds
      }
      if(faceTokenList.length == 0){
        this.$modal.msgError("请选择要删除的图片")
      }
      this.$modal
        .confirm('是否确认删除？')
        .then(function () {
          return faceLibrarydelFace({
            id: id,
            faceToken:faceTokenList
          });
        })
        .then(() => {
          this.getImgFun();
          this.checkAll = false;
          this.isIndeterminate = false;
          this.checkedIds = [];
          this.$modal.msgSuccess("删除成功");
        })
        .catch(() => {});
    },
    // 取消按钮
    cancel() {
      this.open = false
    },
   handleCheckAllChange(value) {
      // 如果全选被勾选，则将所有数据的 id 加入 checkedIds
      this.checkedIds = value ? this.detailsForm.map(item => item.faceToken) : [];
      // 更新半选状态
      this.isIndeterminate = false;
    },
      handleCheckedItemsChange(value) {
        let checkedCount = value.length;
        console.log(value)
        this.checkAll = checkedCount === this.detailsForm.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.detailsForm.length;
      },
  },
  mounted() {
  }
}
</script>
<style scoped>
.details_top{
  display: flex;
  align-items: center;
  justify-content: space-between;

}
</style>


